import xss from 'xss'

export const getSubTopicArray = (storedOptions, validSubTopics) => {
  let subTopicArray = []

  storedOptions.forEach(option => {
    if (option.checked && validSubTopics.includes(option.key)) {
      subTopicArray.push(option.key)
    }
  })

  return subTopicArray
}

export const getSubFilterArray = data => {
  return data.flatMap(category => {
    const children = category.subItems || []
    const checkedChildren = children.filter(item => item.checked)
    const allChecked =
      children.length > 0 && checkedChildren.length === children.length
    if (allChecked) {
      return [category.id]
    }
    return checkedChildren.map(item => item.id)
  })
}

export const buildSubTopicStringWithDetails = (
  subFilterArray,
  subTopicData = []
) => {
  let subTopicString = "not(ampcom:sortingPriorityInt='0')"
  const parentIdSet = new Set(subTopicData.map(item => item.id))
  const subTopicArray = []
  const subTopicDetailsArray = []

  subFilterArray.forEach(id => {
    if (parentIdSet.has(id)) {
      subTopicArray.push(id)
    } else {
      subTopicDetailsArray.push(id)
    }
  })

  const expressionParts = []

  if (subTopicArray.length) {
    expressionParts.push(
      "ampcom:subTopic='" +
        subTopicArray.map(value => xss(value)).join("' or ampcom:subTopic='") +
        "'"
    )
  }

  if (subTopicDetailsArray.length) {
    expressionParts.push(
      "ampcom:subtopicdetails='" +
        subTopicDetailsArray
          .map(value => xss(value))
          .join("' or ampcom:subtopicdetails='") +
        "'"
    )
  }

  if (expressionParts.length) {
    subTopicString += 'and(' + expressionParts.join(' or ') + ')'
  }

  if (window._satellite?.track) {
    window._satellite.track(
      'getUpdatedResources',
      [...subFilterArray.map(value => xss(value))].join(',')
    )
  }

  return subTopicString
}

export const buildSubTopicString = subTopicArray => {
  let subTopicString = ''
  if (subTopicArray.length) {
    subTopicString =
      "not(ampcom:sortingPriorityInt='0')and(ampcom:subTopic='" +
      subTopicArray.map(value => xss(value)).join("' or ampcom:subTopic='") +
      "')"

    if (window._satellite?.track) {
      window._satellite.track(
        'getUpdatedResources',
        subTopicArray.map(value => xss(value)).join(',')
      )
    }
  } else {
    subTopicString = "not(ampcom:sortingPriorityInt='0')"
  }

  return subTopicString
}

export const buildUrl = (subTopicString, sortBy, offset, limit) => {
  const url = new URL('/halapi/ampcom:Article', window.location.origin)
  url.searchParams.append(
    '_scope',
    '/content/documents/ampcom/financial-goals--priorities/articles'
  )
  url.searchParams.append('_expr', xss(subTopicString))
  url.searchParams.append('_sort', xss(sortBy))
  url.searchParams.append('_offset', offset ? xss(offset) : 0)
  url.searchParams.append('_limit', limit)

  const relativeUrl = url.pathname + url.search

  return decodeURIComponent(relativeUrl.replaceAll('+', ' '))
}
